<script>
import MovedNotice from '@/components/MovedNotice.vue'

const TARGETS = {
    adminRaceControl: { title: 'Race Control', path: '/admin/internal/race_control/' },
    adminCalendars: { title: 'Daily Planner', path: '/admin/internal/planner/' },
}

export default {
    name: 'AdminMoved',
    components: { MovedNotice },
    computed: {
        target() {
            return TARGETS[this.$route.name] || TARGETS.adminRaceControl
        },
        url() {
            return `${this.$appConfig('API_BASE_URL')}${this.target.path}`
        },
    },
}
</script>

<template>
    <moved-notice :title="target.title" :url="url" />
</template>
